import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SummerEditor = _resolveComponent("SummerEditor")!

  return (_openBlock(), _createElementBlock("div", {
    id: "MessageCenter__Editor",
    class: _normalizeClass(`${_ctx.isImportant ? 'highlight-important' : ''}`)
  }, [
    _createVNode(_component_SummerEditor, {
      isImportant: _ctx.isImportant,
      options: _ctx.editorOptions,
      ref: "summerEditorRef",
      "refs-Name": _ctx.refsName,
      "initial-value": _ctx.sanitizeMarkup(_ctx.markdownToHtml(_ctx.initialMessage)),
      result: _ctx.result,
      "onUpdate:result": _ctx.updateResult,
      selectedProfile: _ctx.selectedProfile,
      "onUpdate:selectedProfile": _ctx.updateSelectedProfile,
      allSelectedProfiles: _ctx.allSelectedProfiles,
      selectedConversation: _ctx.activeConversation,
      editMsg: _ctx.editMsg,
      "onUpdate:msgFiles": _ctx.updateMsgFiles,
      onSendMessage: _ctx.sendMessage,
      shouldDisableSend: _ctx.shouldDisableSend,
      isFamilyPortal: _ctx.isFamilyPortal
    }, null, 8 /* PROPS */, ["isImportant", "options", "refs-Name", "initial-value", "result", "onUpdate:result", "selectedProfile", "onUpdate:selectedProfile", "allSelectedProfiles", "selectedConversation", "editMsg", "onUpdate:msgFiles", "onSendMessage", "shouldDisableSend", "isFamilyPortal"])
  ], 2 /* CLASS */))
}